/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./j-image.vue?vue&type=template&id=0942352e&scoped=true"
import script from "./j-image.vue?vue&type=script&lang=js"
export * from "./j-image.vue?vue&type=script&lang=js"
import style0 from "./j-image.vue?vue&type=style&index=0&id=0942352e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0942352e",
  null
  
)

export default component.exports
import QIntersection from 'quasar/src/components/intersection/QIntersection.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIntersection});
